export const kMatterListCacheDuration = 60 * 1000 // Cache Duration - 60 seconds
export const kMatterPollingIntervalMs = 30 * 1000 // Collaboration polling interval - 30 seconds

// BE error detail strings
export const kBEMatterAlreadyExistsDetail = 'Matter already exists'
export const kBEMatterNameReservedDetail = 'Matter name is reserved and cannot be used.'

// User-facing error messages
export const kMatterDialogGenericErrorMessage = 'Something went wrong. Please try again.'
export const kMatterNameExistsErrorMessage = 'A matter with this name already exists.'
export const kMatterNameReservedErrorMessage = 'This matter name is reserved and cannot be used.'

export const kMattersRoute = '/dashboard/matters'
export const kSessionStorageActiveMatterIdKey = 'activeMatterId'

export const kMaxMatterContextLength = 4000
export const kMaxMatterHardLimit = 5000

/** Fallback label when a matter has no name or is missing */
export const kUntitledMatterLabel = 'Untitled Matter'

/**
 * Display description for the legacy unassigned matter (read-only migration bucket).
 * Shown instead of the stored description so users know how to continue working.
 */
export const kUnassignedMatterDescription =
  'We’ve saved your previous chats and documents here because they weren’t associated with a matter. Assign items to a matter to continue work and maintain proper case context.'

/** Label for the "Move to Matter" menu item */
export const kMoveToMatterLabel = 'Move to Matter'
